import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IGetDocumentsInterventionResponse from 'services/httpClient/responses/intervention/IGetDocumentsInterventionResponse';

import { interventionActions } from '../index';
import { IGetInterventionDocumentsRequestAction } from '../reducers/getDocuments/request';

function* getDocuments(
  action: PayloadAction<IGetInterventionDocumentsRequestAction>,
) {
  try {
    const response: AxiosResponse<IGetDocumentsInterventionResponse[]> =
      yield call(
        rikHttpClient.get,
        `interventions/${action.payload.data.id}/documents`,
      );
    // remove other file_type documents
    const data = response.data.filter(doc => doc.file_type !== 'other');
    yield put(interventionActions.getDocumentsSuccess({ documents: data }));
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(interventionActions.getDetailsFailure());
  }
}

export default getDocuments;
